var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-multiselect',{attrs:{"value":_vm.value,"name":_vm.name,"options":_vm.timeOptions,"placeholder":_vm.placeholder,"error":_vm.error,"data-vv-as":_vm.vvAs},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }